module.exports = __webpack_public_path__ + "static/media/logo.23a32c4e.svg";